import React from "react";
import PropTypes from "prop-types";

import { Nav, NavItem } from "react-bootstrap";
import { LinkContainer, IndexLinkContainer } from "react-router-bootstrap";
import {
  IoChevronBack,
  IoPerson,
  IoPeople,
  IoReorderFour,
  IoSettings,
  IoAnalytics,
  IoDocumentText,
  IoCalendarNumber,
  IoList,
  IoAlbums,
  IoPeopleCircleOutline
} from "react-icons/io5";

import MenuFooter from "./MenuFooter";

const SettingsMenu = ({ onClickMenu }) => (
  <Nav className="sidebar sidebar-nav">
    <IndexLinkContainer to="/app/dashboard">
      <NavItem eventKey={1} onClick={onClickMenu}>
        <IoChevronBack size={16} />
        Exit Settings
      </NavItem>
    </IndexLinkContainer>
    <NavItem className="menu-header">Company</NavItem>
    <LinkContainer to="/app/settings/users">
      <NavItem eventKey={3} className="submenu-item" onClick={onClickMenu}>
        <IoPeople size={15} />
        <span>Users</span>
      </NavItem>
    </LinkContainer>
    <LinkContainer to="/app/settings/roles">
      <NavItem eventKey={3} className="submenu-item" onClick={onClickMenu}>
        <IoPerson size={15} />
        <span>Roles</span>
      </NavItem>
    </LinkContainer>
    <LinkContainer to="/app/settings/departments">
      <NavItem eventKey={3} className="submenu-item" onClick={onClickMenu}>
        <IoPeopleCircleOutline size={15} />
        <span>Departments</span>
      </NavItem>
    </LinkContainer>
    <LinkContainer to="/app/settings/holidays">
      <NavItem eventKey={3} className="submenu-item" onClick={onClickMenu}>
        <IoCalendarNumber size={15} />
        <span>Holidays</span>
      </NavItem>
    </LinkContainer>
    <NavItem className="menu-header">System</NavItem>
    <LinkContainer to="/app/settings/services">
      <NavItem eventKey={3} className="submenu-item" onClick={onClickMenu}>
        <IoReorderFour size={15} />
        <span>Services</span>
      </NavItem>
    </LinkContainer>
    <LinkContainer to="/app/settings/tasks">
      <NavItem eventKey={3} className="submenu-item" onClick={onClickMenu}>
        <IoList size={15} />
        <span>Tasks</span>
      </NavItem>
    </LinkContainer>
    <LinkContainer to="/app/settings/codes">
      <NavItem eventKey={3} className="submenu-item" onClick={onClickMenu}>
        <IoSettings size={15} />
        <span>Codes</span>
      </NavItem>
    </LinkContainer>
    <LinkContainer to="/app/settings/contract-tier">
      <NavItem onClick={onClickMenu}>
        <IoDocumentText size={15} />
        <span>Contract Tiers</span>
      </NavItem>
    </LinkContainer>
    <LinkContainer to="/app/settings/department-categories">
      <NavItem onClick={onClickMenu}>
        <IoAlbums size={15} />
        <span>Dept Categories</span>
      </NavItem>
    </LinkContainer>
    <NavItem className="menu-header">Logs</NavItem>
    <LinkContainer to="/app/settings/activity">
      <NavItem onClick={onClickMenu}>
        <IoAnalytics size={15} />
        <span>Activity</span>
      </NavItem>
    </LinkContainer>
    <MenuFooter />
  </Nav>
);
SettingsMenu.propTypes = {
  onClickMenu: PropTypes.func
};

export default SettingsMenu;
